export default __webpack_public_path__ + "static/media/icon-shopping.8866e39d.svg";